import React from 'react';

import { Box } from '@mui/material';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';

import { AvailableButtonStyle } from '@components/molecules/enrollButton/availableButton/style';
import PurchaseRemark from '@components/share/custom/purchaseRemark';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type AvailableRegisterButtonProps = {
  onClick: typeof noop;
  isFooter?: boolean;
  isFree?: boolean;
  isDisableActionIcon?: boolean;
  isLoading?: boolean;
  bundleDetailSeo: BundleEntity;
};

const AvailableRegisterButton = ({
  onClick = noop,
  isFooter = false,
  isFree = false,
  isDisableActionIcon = false,
  isLoading = false,
  bundleDetailSeo,
}: AvailableRegisterButtonProps) => {
  const { t } = useTranslation('store_course');

  if (isFree) {
    return (
      <PurchaseRemark
        title={t('course_detail.header_banner.purchase.unavailable.published.button.text')}
        icon="fa-light fa-times-circle"
        isFooter={isFooter}
      />
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      width="100%"
      height={isFooter ? '40px' : '60px'}
      sx={{
        mt: {
          lg: isFooter ? '16px' : '0px',
        },
      }}
    >
      <Box
        sx={{
          width: {
            lg: isFooter ? '310px' : '100%',
            md: isFooter ? '310px' : '100%',
            xs: isFooter ? '200px' : '100%',
          },
        }}
      >
        <AvailableButtonStyle
          loading={isLoading}
          onClick={onClick}
          variant="contained"
          color="inherit"
          style={{ width: '100%', height: isFooter ? '100%' : '60px' }}
          isFooter={isFooter}
        >
          {t('course_detail.header_banner.purchase.available_register.button.text')}
        </AvailableButtonStyle>
      </Box>
      {/* TODO: implement like and share bundle */}
      {/* {isDisableActionIcon ? null : <LikeAndShareBundle bundleDetailSeo={bundleDetailSeo} />} */}
    </Box>
  );
};

export default AvailableRegisterButton;
